import { AxiosResponse } from 'axios';
import { APIConfig, throttle } from 'src/config';
import { PaginationAndFilter } from 'src/interfaces/common/pagination';
import { wait } from 'src/utils/wait';
import { CustomerAccountDeletionRequestsDetails, UpdateStatusUserDeleteRequest } from 'src/interfaces/customers/customers';
import axiosClient from '../utils/axios-client';

export class CustomerADRequestApi {
  private requestManagementUrl = APIConfig.requestManagementUrl;

  // update status of request
  async updateStatus(requestId: string, updateStatusDetails: UpdateStatusUserDeleteRequest):
  Promise<{ responseData: CustomerAccountDeletionRequestsDetails, statusCode: number }> {
    try {
      const res = await axiosClient.put(`${this.requestManagementUrl}user/deletion/requests/${requestId}/status`, updateStatusDetails).then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async getAccountDeletioRequestsByPaginationAndFilters(options: PaginationAndFilter):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .post(`${this.requestManagementUrl}user/deletion/requests/getByPaginationAndFilter`, options)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async getAccountDeletionRequestsFilterData():Promise<AxiosResponse> {
    if (throttle) {
      await wait(throttle);
    }

    const response = await axiosClient.get(`${this.requestManagementUrl}user/deletion/requests/filters/data`);

    return response;
  }
}

export const accountDeletionRequestApi = new CustomerADRequestApi();
